<template>
  <BuilderSelect
    class="w-full text-xs"
    :modelValue="modelValue"
    @update:modelValue="$emit('update:modelValue', $event)">
    <option value="">Select property…</option>
    <option v-if="modelValue && !options.some(option => option.value === modelValue)" :value="modelValue">
      {{ modelValue }} · saved value
    </option>
    <option v-for="option in options" :key="option.value" :value="option.value">
      {{ option.label }}
    </option>
  </BuilderSelect>
</template>

<script setup>
import { computed } from 'vue'
import BuilderSelect from '../hassbuilder/automation/BuilderSelect.vue'
import { availableEntityProperties, propertyMetadata } from '../../gpio/gpioEditorModel.js'

const props = defineProps({
  modelValue: { type: String, default: '' },
  entity: { type: Object, default: null },
  mode: { type: String, default: 'state' },
  objectType: { type: String, default: '' },
  event: { type: String, default: '' },
})
defineEmits(['update:modelValue'])

function propertyLabel(property) {
  const metadata = propertyMetadata(props.entity, property)
  const type = metadata?.type || (property === 'state' ? 'boolean' : 'integer')
  const range = metadata?.min !== undefined && metadata?.max !== undefined ? ` ${metadata.min}–${metadata.max}` : ''
  const writable = metadata?.writable === false ? ' read-only' : ' writable'
  return `${property} · ${type}${range}${writable}`
}

const options = computed(() => availableEntityProperties(props.entity, {
  mode: props.mode,
  objectType: props.objectType,
  event: props.event,
  bindingProperty: props.modelValue,
}).map(value => ({ value, label: propertyLabel(value) })))
</script>
